import { Component, Inject, OnInit } from '@angular/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-marketplace-filter',
  templateUrl: './marketplace-filter.component.html',
  styleUrls: ['./marketplace-filter.component.scss'],
})
export class MarketplaceFilterComponent implements OnInit {

  tmp: boolean = false;
  categoryList: any;
  categoryIds: any;
  catarr: any;
  brandList: any;
  brandValue: any;
  brandarr: any;
  productnameList: any;
  productnamearr: any;
  versionList: any;
  versionarr: any;
  businesskobjList: any;
  businessobjarr: any;
  methodList: any;
  methodarr: any;
  typeList: any;
  typearr: any;
  priceDealsList: any;
  pricearr: any;
  filterarr: any;
  currDiv: string = 'Category';

  constructor(
    private backendService: BackendService,
    public helperService: HelperService,
    public storage: Storage,
    private _bottomSheetRef: MatBottomSheetRef<MarketplaceFilterComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) { }
  
  ngOnInit() {
    this.categoryList     = this.data.categoryList;
    this.categoryIds      = this.data.categoryIdsData;
    this.catarr           = this.data.categoryArray;
    this.brandList        = this.data.brandList;
    this.brandarr         = this.data.brandArray;
    this.productnameList  = this.data.productNameList;
    this.productnamearr   = this.data.productNameArray;
    this.versionList      = this.data.versionList;
    this.versionarr       = this.data.versionArray;
    this.businesskobjList = this.data.buisnessObjList;
    this.businessobjarr   = this.data.buisnessObjArray;
    this.methodList       = this.data.methodList;
    this.methodarr        = this.data.methodArray;
    this.typeList         = this.data.typeList;
    this.typearr          = this.data.typeArray;
    this.priceDealsList   = this.data.priceList;
    this.pricearr         = this.data.priceArray;
    this.filterarr        = this.data.filterArray;
  }

  showDiv(divVal: string) {
    this.currDiv = divVal;
  }

  checkUncheckAll(catalogId, catalogName, catalog, e) {
    this.catarr = [];
    this.brandarr = [];
    this.filterarr = this.filterarr.filter(function( obj ) {
      return obj.Category !== 'Category' && obj.Category !== 'Brand';
    });
    //this.categoryIds = [...new Set(this.categoryList.map(item => item.id))];
    if(e.checked == true && catalogName == 'All') {
      this.categoryList.forEach(val => {
        val.IsChecked = false;
        if (val.id == catalogId) val.IsChecked = !val.IsChecked;
      });
      this.onChangeGetBrands(this.categoryIds, e.checked);
    }

    else if (e.checked == true && catalogName != 'All') {
      this.categoryList.forEach(val => {
        val.IsChecked = false;
        if (val.id == catalogId) val.IsChecked = !val.IsChecked;
      });
      this.onChangeGetBrands(catalogId, e.checked);
      this.category(catalogId, catalogName, catalog, e);
    }

    else {
      this.categoryList.forEach(val => {
        val.IsChecked = false;
      });
      this.onChangeGetBrands(this.categoryIds, true);
    }
    
  }

  onChangeGetBrands(val, event) {
    this.brandValue = [];
    if (event) {
      val instanceof Array ? this.brandValue = val : this.brandValue.push(val);
    }
    
    let payload = { "categories": this.brandValue }
    this.getStorage().then((res) => {
      this.backendService
        .PostAPICall('getBrandsByCategoryIds', payload, res.token)
        .subscribe((data) => {
          if (data) {
            this.brandList = data.data;
            for (let c of this.brandList) {
              c.Category = "Brand";
              c.name = c.brand;
            }
          }    
          else {
            this.brandList = [];
          }
        });
      (error) => {
        this.helperService.handleError(error);
      };
    });
  }

  category(val, name, catalog, event) {
    if (event.checked == true) {
      this.catarr.push(val);
      this.filterarr.push(catalog);
    } else {
      var index = this.catarr.indexOf(val);
      if (index !== -1) {
        this.catarr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  brand(val, name, catalog, event) {
    if (event.checked == true) {
      this.brandarr.push(val);
      this.filterarr.push(catalog);
    } else {
      var index = this.brandarr.indexOf(val);
      if (index !== -1) {
        this.brandarr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  productnames(val, name, catalog, event) {
    if (event.checked == true) {
      this.productnamearr.push(name);
      this.filterarr.push(catalog);
    } else {
      var index = this.productnamearr.indexOf(name);
      if (index !== -1) {
        this.productnamearr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  version(val, name, catalog, event) {
    if (event.checked == true) {
      this.versionarr.push(name);
      this.filterarr.push(catalog);
    } else {
      var index = this.versionarr.indexOf(name);
      if (index !== -1) {
        this.versionarr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  businessobj(val, name, catalog, event) {
    if (event.checked == true) {
      this.businessobjarr.push(name);
      this.filterarr.push(catalog);
    } else {
      var index = this.businessobjarr.indexOf(name);
      if (index !== -1) {
        this.businessobjarr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  method(val, name, catalog, event) {
    if (event.checked == true) {
      this.methodarr.push(val);
      this.filterarr.push(catalog);
    } else {
      var index = this.methodarr.indexOf(val);
      if (index !== -1) {
        this.methodarr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  price(val, name, catalog, event) {
    if (event.checked == true) {
      this.pricearr.push(val);
      this.filterarr.push(catalog);
    } else {
      var index = this.pricearr.indexOf(val);
      if (index !== -1) {
        this.pricearr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  type(val, name, catalog, event) {
    if (event.checked == true) {
      this.typearr.push(val);
      this.filterarr.push(catalog);
    } else {
      var index = this.typearr.indexOf(val);
      if (index !== -1) {
        this.typearr.splice(index, 1);
      }
      const pos = this.filterarr.map(e => e.name).indexOf(name);
      if (pos !== -1) {
        this.filterarr.splice(pos, 1);
      }
    }
  }

  closeBottomSheet() {
    this._bottomSheetRef.dismiss();  
  }

  clearFilters() {
    this.catarr           = [];
    this.brandarr         = [];
    this.productnamearr   = [];
    this.versionarr       = [];
    this.businessobjarr   = [];
    this.methodarr        = [];
    this.typearr          = [];
    this.pricearr         = [];
    this.filterarr        = [];
    for (let c of this.categoryList) {
      c.IsChecked = false;
      c.Category = "Category";
    }
    for (let c of this.brandList) {
      c.IsChecked = false;
      c.Category = "Brand";
      c.name = c.brand;
    }
    for (let c of this.methodList) {
      c.IsChecked = false;
      c.Category = "Method";
    }
    for (let c of this.typeList) {
      c.IsChecked = false;
      c.Category = "Type";
    }
    for (let c of this.priceDealsList) {
      c.IsChecked = false;
      c.Category = "Price";
    }
    for (let c of this.productnameList) {
      c.IsChecked = false;
      c.Category = "ProductName";
      c.name = c.name.trim().replace(/ +/g,' ').split('_').join(' ');
    }
    for (let c of this.versionList) {
      c.IsChecked = false;
      c.Category = "Version";
    }
    for (let c of this.businesskobjList) {
      c.IsChecked = false;
      c.Category = "Businesskobj";
    }

    const clearData = {
      data: {
        categoryData     : this.categoryList,
        categoryArray    : this.catarr,
        brandData        : this.brandList,
        brandArray       : this.brandarr,
        productNameData  : this.productnameList,
        productNameArray : this.productnamearr,
        versionData      : this.versionList,
        versionArray     : this.versionarr,
        buisnessObjData  : this.businesskobjList,
        buisnessObjArray : this.businessobjarr,
        methodData       : this.methodList,
        methodArray      : this.methodarr,
        typeData         : this.typeList,
        typeArray        : this.typearr,
        priceDealsData   : this.priceDealsList,
        priceArray       : this.pricearr,
        filterArray      : this.filterarr
      }

    }
    this._bottomSheetRef.dismiss(clearData);
  }

  showFilters() {
    if (this.categoryList.every(({IsChecked}) => !IsChecked) ) {
      this.categoryList.filter(val => {
        if(val.name == 'All') {
          val.IsChecked = true;
        }
      });
    }
    const filterData = {
      data: {
        categoryData     : this.categoryList,
        categoryArray    : this.catarr,
        brandData        : this.brandList,
        brandArray       : this.brandarr,
        productNameData  : this.productnameList,
        productNameArray : this.productnamearr,
        versionData      : this.versionList,
        versionArray     : this.versionarr,
        buisnessObjData  : this.businesskobjList,
        buisnessObjArray : this.businessobjarr,
        methodData       : this.methodList,
        methodArray      : this.methodarr,
        typeData         : this.typeList,
        typeArray        : this.typearr,
        priceDealsData   : this.priceDealsList,
        priceArray       : this.pricearr,
        filterArray      : this.filterarr
      }

    }
    this._bottomSheetRef.dismiss(filterData);
  }
    
  async getStorage() {
    let data = {
      token: await this.storage.get('token'),
      userId: await this.storage.get('id'),
      showDialog: await this.storage.get('showDialog'),
    };
    return data;
  }

}
